module.exports = __webpack_public_path__ + "img/g0007.b51b4924.png";